import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Title } from "../../utils/consts";
import "./headerLogo.css";

export default class HeaderLogo extends Component {
  render() {
    return (
      <Link title={Title} to={"/"}>
        <div className="header__logo" />
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/headerLogo/HeaderLogo.js